/**
 * Handle Mobile Navigation Dropdown
 */
const handleNavigationMobileDropdown = () => {
	const $navigation = $('.nav');
	const mobileBreakpoint = 768;

	$navigation.on('click', '.has-dropdown > a', function(event) {
		if ($(window).innerWidth() >= mobileBreakpoint) {
			return;
		}

		const $this = $(this);
		const $dropdownParent = $this.closest('li');

		$dropdownParent.toggleClass('is-active').siblings().removeClass('is-active');
		$dropdownParent.find('> ul').slideToggle().parent().siblings().find('> ul').slideUp();

		event.preventDefault();
	});
}

handleNavigationMobileDropdown();
